import uploadshomepagebannerbgimageshutterstock_1092700045FirstFrameJpg from "$lib/data/generated/uploads/home/PageBanner/bgImage/shutterstock_1092700045-first-frame.jpg";
import uploadshomepagebannerbgvideoshutterstock_1092700045Mp4 from "$lib/data/generated/uploads/home/PageBanner/bgVideo/shutterstock_1092700045.mp4";

export const uploads = {
  "uploads/home/PageBanner/bgImage/shutterstock_1092700045-first-frame.jpg": uploadshomepagebannerbgimageshutterstock_1092700045FirstFrameJpg,
  "uploads/home/PageBanner/bgVideo/shutterstock_1092700045.mp4": uploadshomepagebannerbgvideoshutterstock_1092700045Mp4
};